<template>
<div>
  <search />
  <div class="container dashboard">
    <v-news-alert
      v-if="latestFeaturedNewsItem && showNews === true"
      :newsItem="latestFeaturedNewsItem" :news="'Verpakkingswijziging SpeediCath Flex'"
      :html="true" @close="closeNews()"
      :message="'<b>Verpakkingswijziging</b> SpeediCath Flex De katheters van SpeediCath Flex Ch10, Ch12, Ch14 en Ch16 hebben een nieuwe verpakking, van SpeediCath Flex Ch10, Ch12, Ch1'">
    </v-news-alert>
    <v-ppw-rec-id-to-do-list></v-ppw-rec-id-to-do-list>
    <v-news-preview :newsItems="newsItems"></v-news-preview>
    <div v-if="showDemoPopUpRequest()">
      <v-overlay>
        <transition>
          <div class="dashboard__popup">
            <img src='@/static/img/mascotLaugh.svg' class="demoGuyImage">
            <h2>Welkom op het voorschrijfportaal van Mediq</h2>
            <legend>Wat leuk dat u er bent! Het vernieuwde voorschrijfportaal van Mediq is aangevuld met een aantal functies die uw werk nóg makkelijker maken. Omdat dit even wennen kan zijn, hebben we een live tour gemaakt om samen door het platform heen te lopen, en u kennis te laten maken met het nieuwe voorschrijven. Laten we beginnen met de tour!
            </legend>
            <div class="row grid-margin grid-justify-content-right dashboard__actions">
              <v-button tagelement="a" sm hollow class="cancelDemo" @click.native="cancelDemo">Nee dank je</v-button>
              <v-button tagelement="button" sm primary @click.native="activateDemo">Ja graag</v-button>
            </div>
          </div>
        </transition>
      </v-overlay>
    </div>
  </div>
</div>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import VPpwRecIdToDoList from '@/components/sections/toDos/PpwRecIdToDoList'
import VNewsPreview from '@/components/sections/news/NewsPreview'
import VNewsAlert from '@/components/shared/NewsAlert'
import Search from '@/components/sections/search/Search'
import { currentUserIdentity$ } from '@/services';

export default {
  name: 'Dashboard',
  components: {
    VNewsPreview,
    VNewsAlert,
    VPpwRecIdToDoList,
    Search
  },
  subscriptions () {
    return {
      user: currentUserIdentity$
    }
  },
  data () {
    return {
      showDemoPopUpAction: false,
      animated: false,
      showNews: true
    }
  },
  computed: {
    ...mapGetters({
      newsItems: 'news/getNewsItems',
      latestFeaturedNewsItem: 'news/getLatestFeaturedNewsItem'
    })
  },
  created () {
    store.dispatch('news/fetchNewsItems', 3)
    store.dispatch('news/fetchLatestFeaturedNewsItem')
  },
  methods: {
    showDemoPopUpRequest () {
      if (this.showDemoPopUpAction || store.state.navigation.demoActivated) {
        return false
      }
      return store.state.navigation.demo
    },
    activateDemo () {
      store.commit('navigation/setDemoActivation', true)
      this.showDemoPopUpAction = true
      this.showDemoPopUpRequest()
    },
    cancelDemo () {
      store.commit('navigation/setDemoActivation', false)
      store.dispatch('navigation/updateDemoStatus', false)
      this.showDemoPopUpAction = false
      this.showDemoPopUpRequest()
    },
    closeNews () {
      this.animated = true
      setTimeout(() => {
        this.animated = false
        this.showNews = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  &__view {
    padding: 0px;
  }
}
.dashboard {
  padding-top: 35px;
  &.isfullwidth {
    max-width: 100%;
  }
  .overlay {
    background: rgba(0,0,0,.7);
  }
  .demoGuyImage {
    height: 90px;
    width: 75px;
    position: absolute;
    bottom: 0;
    left: -40px;
  }
  &__actions {
    margin-top: 35px;
  }
  .cancelDemo {
    border: none !important;
  }
  & > * {
    margin-bottom: 1rem;
  }
}
</style>
